import React, { PureComponent } from 'react';
import { PrimaryLink } from 'jl-design-system/elements/link/Link';
import PropTypes from 'prop-types';
import { scrollTo } from 'jl-design-system/utils/scroll/scrollTo';
import setPageTitle from '../../utils/helpers/pageTitle';

import styles from './session-expired.scss';

class SessionExpired extends PureComponent {

  static propTypes = {
    canonicalURL: PropTypes.string,
    showBackToBasket: PropTypes.bool,
    showBackToPDP: PropTypes.bool,
  }

  static defaultProps = {
    canonicalURL: '',
    showBackToBasket: false,
    showBackToPDP: false,
  };

  componentDidMount() {
    setPageTitle('Session expired');
    setTimeout(() => {
      scrollTo(0);
    }, 50);
  }

  render() {
    const {
      canonicalURL,
      showBackToBasket,
      showBackToPDP,
    } = this.props;

    return (
      <div className={styles.container}>
        <h2 className={styles.title}>Sorry, your session has expired</h2>
        {
          !showBackToPDP &&
          <p>
            We signed you out to keep your information secure.
            Please return to the basket to continue with your order.
          </p>
        }
        {
          showBackToPDP &&
          <p>
            We signed you out to keep your information secure.
            Please return to the product page to continue with your order.
          </p>
        }
        {
          showBackToBasket && !showBackToPDP &&
          <PrimaryLink
            external
            to={`${window.publicJLSiteDomain}/basket`}
          >
            Return to basket
          </PrimaryLink>
        }
        {
          showBackToPDP &&
          <PrimaryLink
            external
            to={`${window.publicJLSiteDomain}/${canonicalURL}`}
          >
            Return to your product
          </PrimaryLink>

        }
      </div>
    );
  }
}

export default SessionExpired;
